// Phone numbers are stored in E.164 ("+919876543210"). Indian numbers can be
// typed any common way: "98765 43210", "098765-43210", "+91 98765 43210".

export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  const hasPlus = trimmed.startsWith('+');
  let digits = trimmed.replace(/\D/g, '');
  if (hasPlus) {
    if (digits.startsWith('91')) return indian(digits.slice(2));
    return /^[1-9]\d{7,14}$/.test(digits) ? `+${digits}` : null;
  }
  if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
  return indian(digits);
}

function indian(ten: string): string | null {
  return /^[6-9]\d{9}$/.test(ten) ? `+91${ten}` : null;
}

/**
 * Whether a search finds this number, however it's typed: "98765 43210",
 * "098765-43210", "+91 98765…" or just the last few digits. Searches with
 * letters in them are names, not numbers.
 */
export function phoneMatches(phone: string | null | undefined, query: string): boolean {
  if (!phone || /[a-z]/i.test(query)) return false;
  let digits = query.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
  return digits.length >= 3 && phone.replace(/\D/g, '').includes(digits);
}

/** "+919876543210" → "98765 43210"; other countries keep their + form. */
export function formatPhone(e164: string | null | undefined): string {
  if (!e164) return '';
  if (e164.startsWith('+91') && e164.length === 13) return `${e164.slice(3, 8)} ${e164.slice(8)}`;
  return e164;
}

/** Digits for wa.me links: "+919876543210" → "919876543210" */
export function whatsappDigits(e164: string): string {
  return e164.replace(/\D/g, '');
}
